import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Target the actual scrollable container (main element inside Layout)
    const mainEl = document.getElementById("main-scroll-container");
    if (mainEl) {
      mainEl.scrollTo(0, 0);
    }
    // Fallback for pages rendered outside the Layout (e.g., public pages)
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;